import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/tickets/")({
  head: () => ({ meta: [{ title: "Tickets | Admin" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-tickets-index")),
});
